import { Auth } from '~/amplify';
import {
  DEV_PHONE_VERIFICATION_CODE,
  PHONE_NUMBER_ATTRIBUTE_KEY,
} from '~/components/page/Auth/constants';
import isDevEnvironment from '~/util/isDevEnviroment';

const confirmPhoneNumberAttribute = async (code: string) => {
  if (isDevEnvironment() && code === DEV_PHONE_VERIFICATION_CODE) {
    return;
  }

  const result = await Auth.confirmUserAttribute({
    userAttributeKey: PHONE_NUMBER_ATTRIBUTE_KEY,
    confirmationCode: code,
  });

  return result;
};

export default confirmPhoneNumberAttribute;
